<template>
  <div class="app">
    <div class="app-navbar">
      <navbar></navbar>
    </div>
    <div class="app-sidebar">
      <sidebar></sidebar>
    </div>
    <div class="app-content">
      <router-view />
    </div>
  </div>
</template>

<script>
import Sidebar from "@/components/Sidebar";
import Navbar from "@/components/Navbar";
import AppHeader from "@/components/AppHeader";
import { aquireToken } from "@/requests";
export default {
  components: { Sidebar, AppHeader, Navbar },
  mounted() {}
};
</script>


<style scoped lang="scss">
@import "./styles/mixins";
@import "./styles/variables";
.app {
  width: 100vw;
  height: 100vh;
  min-height: $minheight;
  min-width: $minwidth;

  display: grid;
  grid-template: 1.5fr 9fr / 1fr;
  grid-template-areas:
    "navbar"
    "content";

  @include tablet {
    grid-template: 12fr / 12.5rem 9fr;
    grid-template-areas:
      "sidebar content"
      "sidebar content";
  }

  @include desktop {
    grid-template: 12fr / 12.5rem 10fr;
    grid-template-areas:
      "sidebar content"
      "sidebar content";
  }

  &-header {
    grid-area: header;
    display: none;

    @include tablet {
      display: initial;
    }
  }

  &-navbar {
    grid-area: navbar;
    display: initial;

    @include tablet {
      display: none;
    }
  }

  &-sidebar {
    grid-area: sidebar;
    display: none;
    z-index: 2;

    @include tablet {
      display: initial;
    }
  }

  &-content {
    grid-area: content;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;
    @include tablet {
    }
  }
}
</style>
